var map = {
	"./flag-de.svg": "J7gN",
	"./flag-en.svg": "xjnB",
	"./flag-nl.svg": "C76t"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "k822";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg ^\.\/flag\-.*\.svg$
// module id = k822
// module chunks = 103